// @flow

export const ACTION = 'Action';
export const CART_ACTION = 'Shopping Cart Action';
export const CART_VIEW = 'Shopping Cart View';
export const TOTAL_CART_VALUE = 'Total Cart Value';
